import { createReducer } from '@reduxjs/toolkit'

import { DATES, AGGREGATION } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'

import {
    defaultResourcePageTabs,
    defaultResourcePageWidgets,
    defaultResourcePage,
} from '../defaults'

const defaultState = {
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        order: [DATES, AGGREGATION],
        displayState: {
            [AGGREGATION]: true,
            [DATES]: true,
        },
    },

    ...defaultResourcePage,

    tabs: defaultResourcePageTabs,
    widgets: defaultResourcePageWidgets('productAdPage'),
}

export default createReducer(defaultState, () => {})
